<template>
  <QuestionnaireBase
      :title="title"
      :form="form"
      :finishFunction="null"
      :showNavigationButtons="true"
  >
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "@/views/questionnaires/loadHelpers";

import QuestionnaireBase from "../../../../components/common/questionnaires/questionnaire";
import AssetsEstatePlanning
  from "../../../../components/common/questionnaires/fieldsets/estatePlanning/AssetsEstatePlanning";
import PoliciesEstatePlanning
  from "../../../../components/common/questionnaires/fieldsets/estatePlanning/PoliciesEstatePlanning";
import LiabilitiesEstatePlanning
  from "../../../../components/common/questionnaires/fieldsets/estatePlanning/LiabilitiesEstatePlanning";

export default {
  name: "EstatePlanningFactFindSimpleFinancial",
  mixins: [loadHelpers],
  components: {
    QuestionnaireBase,
    AssetsEstatePlanning,
    PoliciesEstatePlanning,
    LiabilitiesEstatePlanning
  },
  data() {
    return {
      name: 'EstatePlanningFactFindSimpleFinancial',
      title: "Estate Planning Coupon Financial Details",
      url: 'fact_find_full',
      order: [ // imported components required here to load
        'AssetsEstatePlanning',
        'PoliciesEstatePlanning',
        'LiabilitiesEstatePlanning'
      ],
    };
  },
};
</script>
